export default __webpack_public_path__ + "static/media/halo.d5291fe6.webp";